import { parsePhoneNumber } from 'react-phone-number-input';

// ----------------------------------------------------------------------

export function getCountryCode(inputValue, countryCode) {
  if (inputValue) {
    const phoneNumber = parsePhoneNumber(inputValue);
    if (phoneNumber) {
      return phoneNumber?.country;
    }
  }

  return countryCode ?? 'US';
}

// ----------------------------------------------------------------------

export function getCountry(countryCode, countries) {
  const option = countries.filter((country) => country.CountryCode === countryCode)[0];
  return option;
}

export function applyFilter({ inputData, query }) {
  if (query) {
    return inputData.filter(
      (country) =>
        country.Name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        country.PhoneCode.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        country.CountryCode.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return inputData;
}
